import { Close, RemoveRedEye } from '@mui/icons-material';
import { Box, Modal, Tooltip } from '@mui/material'
import { useState } from 'react'
import PersonIcon from '@mui/icons-material/Person';

const TableImage = ({ value }: any) => {
    const [modalOpen, setModalOpen] = useState(false);
    const isImageBase64 = value?.includes("data:image/");
    
    return (
        <>
            {
                isImageBase64 ? <ImagePreview setModalOpen={setModalOpen} modalOpen={modalOpen} value={value} /> : null
            }
            <Tooltip title="Preview Image">
                <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', width: '50px', height: '50px' }}>
                    <Box sx={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: '50' }} onClick={() => setModalOpen(true)} >
                        <RemoveRedEye sx={{ width: '15px', color: 'white' }} />
                    </Box>
                    {isImageBase64 ? <img style={{ width: '50px', height: '50px' }} src={value} alt="" onClick={() => setModalOpen(true)} />
                        : <PersonIcon sx={{ width: '50px', height: '50px' }} />}
                </Box >
            </Tooltip>

        </>
    )
}

export default TableImage

const ImagePreview = ({ setModalOpen, modalOpen, value }: { setModalOpen: any, modalOpen: any, value: any }) => {
    return (
        <Modal
            open={modalOpen}
        >
            <Box sx={{ height: "100vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box onClick={() => setModalOpen(false)} sx={{ position: 'relative', backgroundColor: 'white', borderRadius: '10px', padding: '10px', cursor: 'pointer' }}>
                    <Close sx={{ width: "25px", color: 'white', position: 'absolute', zIndex: '50', top: 10, right: '10px', backgroundColor: "red" }} />
                    {value ? <img style={{ width: '600px', height: '400px' }} src={value} alt="" /> : null}
                </Box>
            </Box>
        </Modal >
    )
}